module.exports = __webpack_public_path__ + "img/16.add2750c.jpg";